import { useContext } from 'react';

import SnackbarCtx from './context';
import { ISnackbarContext } from './types';

export default function useSnackbar(): ISnackbarContext {
  return useContext(SnackbarCtx);
}
